<script setup >
import { onBeforeUnmount, onMounted, ref } from 'vue';
import tippy from 'tippy.js';
import DocumentList from '../editor/DocumentList.vue';
import { LocalProps } from '../localProps';

const {title, placement} = defineProps({
  title: String,
  placement: String
})

const sidebar = ref()
onBeforeUnmount(
  LocalProps.listen(LocalProps.SIDEBAR, val => sidebar.value = val)
)


</script>
<template>

<div    
    :class="[
      'sidebar bg-base-200',
      {'is-open': sidebar}
    ]">
    
    <DocumentList  
      :class="[          
        'absolute  border-r-1 border-base-content/20'
      ]"
      style="height: 100%; min-width: 250px; width: 250px; right: 0"
    />
  </div>

</template>
<style scoped lang="less">


  .sidebar {
    position: absolute;
    z-index: 888;
    top: 0;
    bottom: 0;
    left: 0;
    overflow-x: hidden;




    align-self: stretch; flex-shrink: 0;
    
    transition: width 0.3s ease-in-out;
    width: 0;

    @media (min-width: @light-mode-bp) {
      & {
        position: relative; 
      }
    }


    
  }

  .is-open {
    width: 250px;   
  }


</style>